export enum FormValidationError {
  OVERRIDEN_GAM_PATIENT = 'overriden-gam-patient',
  OVERRIDEN_LOCAL_PATIENT = 'overriden-local-patient',
  INVALID = 'invalid',
}
